export default function WaterlooHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Waterloo%20Iowa%20downtown%20skyline%20with%20Cedar%20River%20at%20golden%20hour%2C%20modern%20and%20historic%20buildings%20along%20the%20riverfront%2C%20professional%20drone%20photography%20with%20warm%20sunset%20colors%20and%20dramatic%20sky%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=waterloo-hero&orientation=landscape"
        alt="Waterloo Iowa downtown skyline with Cedar River at sunset"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 text-center">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Emergency &amp; Expedited Passport Services in Waterloo, IA
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
          International business trip from John Deere or another manufacturing headquarters? UNI student preparing for a study-abroad semester? We help Waterloo and Cedar Falls residents — from tech corridor professionals to university students to agricultural industry travelers — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30&ndash;100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.
        </p>
        <a
          href="https://fastpassportcenter.com/checkout/"
          className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
        >
          Start My Passport <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
            </div>
            <span className="font-semibold">5.0 Reviews</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-award-line text-[#F6C344] text-base"></i>
            <span>BBB A+ Accredited</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-calendar-check-line text-[#F6C344] text-base"></i>
            <span>20+ Years</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-[#F6C344] text-base"></i>
            <span>Registered State Dept. Courier</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-price-tag-3-line text-[#F6C344] text-base"></i>
            <span>Best Price Guarantee</span>
          </div>
        </div>
      </div>
    </section>
  );
}